import { useState } from 'react'

import { Menu } from '@mantine/core'
import { DatePicker, TimeInput } from '@mantine/dates'
import dayjs from 'dayjs'

import { MenuChevron } from 'src/components/Shared/TaskMenus/taskMenuStyles'

// A value + chevron trigger (matching the other rail rows) that opens an inline
// calendar plus a time input. New date picks default to 9 AM but the time can
// be changed. `onChange` receives a Date or null.
const DateTimeMenu = ({
  value,
  onChange,
  placeholder,
  minDate = undefined,
  maxDate = undefined,
}) => {
  const [opened, setOpened] = useState(false)
  const date = value ? new Date(value) : null

  const handleDateChange = (picked) => {
    if (!picked) {
      onChange(null)
      return
    }
    const next = new Date(picked)
    if (date) {
      next.setHours(date.getHours(), date.getMinutes(), 0, 0)
    } else {
      next.setHours(9, 0, 0, 0)
    }
    onChange(next)
  }

  const handleTimeChange = (event) => {
    const time = event.currentTarget.value
    if (!time) return
    const [hours, minutes] = time.split(':').map(Number)
    const next = new Date(date ?? new Date())
    next.setHours(hours, minutes, 0, 0)
    onChange(next)
  }

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      position="bottom-end"
      closeOnItemClick={false}
      classNames={{ dropdown: 'rounded p-2 shadow-sm' }}
    >
      <Menu.Target>
        <button
          type="button"
          className="flex items-center gap-1 text-xs text-doubleNickel-gray-700 hover:text-doubleNickel-gray-900"
        >
          {date ? dayjs(date).format('MM/DD/YYYY h:mmA') : placeholder}
          <MenuChevron />
        </button>
      </Menu.Target>
      <Menu.Dropdown>
        <DatePicker
          size="xs"
          value={date}
          onChange={handleDateChange}
          minDate={minDate}
          maxDate={maxDate}
        />
        <TimeInput
          size="xs"
          className="mt-2"
          value={date ? dayjs(date).format('HH:mm') : ''}
          onChange={handleTimeChange}
        />
      </Menu.Dropdown>
    </Menu>
  )
}

export default DateTimeMenu
